const stats = [
  { value: '36,000+', label: 'Students enrolled' },
  { value: '4', label: 'Expert-led courses' },
  { value: '4.85', label: 'Average rating' },
  { value: '240+', label: 'Hours of content' },
];

export default function Stats() {
  return (
    <section className="bg-foreground-900 py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl sm:text-3xl font-extrabold text-background-50">{stat.value}</p>
              <p className="text-sm text-foreground-400 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}